import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import ReactModal from 'react-modal';

class DeleteProgress extends Component {
    render() {
        return (
            <span className="kbedit-updating">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;Deleting ...
            </span>
        );
    }
}

class CustomRegExDeleteDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);

        this.state = {
            modalOpen: false,
            error: null,
            deleting: false
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_CustomRegExDeleteDialog');
        this.open();
    }

    componentWillUnmount() {
    }

    close() {
        this.setState({
            modalOpen: false,
            deleting: false,
            error: null
        }, () => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        });
    };

    open() {
        this.setState({
            modalOpen: true,
            deleting: false,
            error: null
        });
    };

    onSubmit(e) {
        e.preventDefault();
        this.setState({
            deleting: true
        }, ()=> {
            urlHandler.sendRegexDeleteRequest([{patternName: this.props.patternName}], (resp, status) => {
                if (status != 200) {
                    this.setState({
                        error: decodeURIComponent(resp.error_message),
                        deleting: false
                    })   
                } else {
                    this.close();
                }
            })
        });
    }

    onReset() {
        this.close();
    }

    render() {
        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '0',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                paddingBottom: '5px',
                transform   : 'translate(-50%)',
                maxWidth    : '600px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        const patternName = this.props.patternName && this.props.patternName.length > 45 ? `${this.props.patternName.substring(0,45)}...` : this.props.patternName
        const entityType = this.props.entityType && this.props.entityType.length > 45 ? `${this.props.entityType.substring(0,45)}...` :this.props.entityType
        const pattern = this.props.pattern && this.props.pattern.length > 45 ? `${this.props.pattern.substring(0,45)}...` : this.props.pattern
        const description = this.props.description && this.props.description.length > 45 ? `${this.props.description.substring(0,45)}...` : this.props.description

        return (
           <div id="rm_CustomRegExDeleteDialog">
                <ReactModal ref="deleteId" 
                    isOpen={this.state.modalOpen}
                    contentLabel={this.props.patternName}
                    onRequestClose={this.close} 
                    style={styles}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={1000}>
                    <div className="kbedit">
                        <div className="kbedit-header">
                            <span className="header-text">Delete Custom RegEx</span>
                        </div> 

                        <div className="kbedit-content" style={{maxHeight: '300px'}}>
                            Are you sure you want to delete the following RegEx Pattern from your extractions?<br/>
                            <br/>
                            <i>Pattern Name:    {patternName}</i><br/>
                            <i>Entity Type:     {entityType}</i><br/>
                            <i>RegEx Pattern:   {pattern}</i><br/>
                            <i>Description:     {description}</i>
                            <br/>
                        </div>
                        <div className="kbedit-footer">
                            {this.state.deleting ? <DeleteProgress /> : null}
                            {this.state.error ? <span className="kbedit-delete-error">{this.state.error}</span> : null}
                            <span style={{color: '#00a2ae'}}>NOTE: This action cannot be undone.</span>
                            <button type="button" className="kbedit-default-button" onClick={this.onSubmit}>Delete</button>
                            <button type="button" className="kbedit-default-button" onClick={this.onReset}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

CustomRegExDeleteDialog.propTypes = {
    // matchText: PropTypes.string.isRequired,
    // entityType: PropTypes.string.isRequired,
    // action: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onDelete: PropTypes.func
};

export default CustomRegExDeleteDialog;

// export function CustomRegExDeleteDialog(type, label, id, callback) {
    export function customRegExDeleteDialog(patternName, pattern, entityType, description, callback) {
    
    var divTarget = document.getElementById('react-custom-regex-delete-dialog')

    var close = (ans) => {
        if (divTarget) {
            ReactDOM.unmountComponentAtNode(divTarget);
        }
        if (callback) {
            callback(ans);
        }
    }

    if (divTarget) {
        ReactDOM.render(<CustomRegExDeleteDialog patternName={patternName} pattern={pattern} entityType={entityType} description={description} onClose={close}/>, divTarget);
    } else {
        divTarget = document.createElement('div')
        divTarget.id = 'react-custom-regex-delete-dialog'
        document.body.appendChild(divTarget)
        ReactDOM.render(<CustomRegExDeleteDialog patternName={patternName} pattern={pattern} entityType={entityType} description={description} onClose={close}/>, divTarget);
    }
 }


